
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Plus, Search } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface TemplatesHeaderProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
}

const TemplatesHeader = ({ searchTerm, onSearchChange }: TemplatesHeaderProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleCreateTemplate = () => {
    navigate("/templates/create");
  };

  return (
    <>
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6">
        <div>
          <h1 className="text-2xl font-bold">{t('templates.header.title')}</h1>
          <p className="text-muted-foreground mt-1">
            {t('templates.header.subtitle')}
          </p>
        </div>

        <Button
          className="mt-4 sm:mt-0"
          onClick={handleCreateTemplate}
        >
          <Plus size={16} className="mr-2" />
          <span>{t('templates.header.create_btn')}</span>
        </Button>
      </div>

      <div className="mb-6">
        <div className="relative">
          <Search size={16} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" />
          <Input
            placeholder={t('templates.header.search_placeholder')}
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-9"
          />
        </div>
      </div>
    </>
  );
};

export default TemplatesHeader;
